export enum IMAGE_FIT {
  COVER = 'cover',
  CONTAIN = 'contain',
}